import { Injectable } from '@angular/core';
import { EmissionLine } from '../enums/emission-line-type';

@Injectable({
  providedIn: 'root'
})
export class SpectrumService {
  public emissionLineEnergy(zNumber: number, line: EmissionLine) {
    const emissionLine = [
    // Ka1   Ka2     Kb1     Kb2     La1     La2     Lb1     Lb2     Lg1
    [0,		   0,      0,      0,      0,      0,      0,      0,      0],
    [0.001,	 0.001,	 0.001,	 0.001,	 0.000,	 0.000,	 0.000,	 0.000,  0.000],     //
    [0.001,	 0.001,	 0.001,	 0.001,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     //  2    He
    [0.054,	 0.054,	 0.054,	 0.054,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     //  3    Li
    [0.109,	 0.109,	 0.109,	 0.109,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     //  4    Be
    [0.183,	 0.183,	 0.183,	 0.183,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     //  5    B
    [0.277,	 0.277,	 0.277,	 0.277,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     //  6    C
    [0.392,	 0.392,	 0.392,	 0.392,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     //  7    N
    [0.525,	 0.525,	 0.525,	 0.525,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     //  8    O
    [0.677,	 0.677,	 0.677,	 0.677,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     //  9    F
    [0.849,	 0.849,	 0.849,	 0.849,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     // 10    Ne
    [1.041,	 1.041,	 1.071,	 1.071,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     // 11    Na
    [1.254,	 1.254,	 1.302,	 1.302,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     // 12    Mg
    [1.487,	 1.486,	 1.557,	 1.557,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     // 13    Al
    [1.740,	 1.739,	 1.836,	 1.836,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     // 14    Si
    [2.014,	 2.013,	 2.139,	 2.139,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     // 15    P
    [2.308,	 2.307,	 2.464,	 2.464,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     // 16    S
    [2.622,	 2.621,	 2.816,	 2.816,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     // 17    Al
    [2.958,	 2.956,	 3.191,	 3.191,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     // 18    Ar
    [3.314,	 3.311,	 3.590,	 3.590,	 0.000,	 0.000,	 0.000,	 0.000,	 0.000],     // 19    K
    [3.692,	 3.688,	 4.013,	 4.013,	 0.341,	 0.341,	 0.345,	 0.000,	 0.000],     // 20    Ca
    [4.091,	 4.086,	 4.461,	 4.461,	 0.395,	 0.395,	 0.400,	 0.000,	 0.000],     // 21    Sc
    [4.511,	 4.505,	 4.932,	 4.932,	 0.452,	 0.452,	 0.458,	 0.000,	 0.000],     // 22    Ti
    [4.952,	 4.945,	 5.427,	 5.427,	 0.511,	 0.511,	 0.519,	 0.000,	 0.000],     // 23    V
    [5.415,	 5.406,	 5.947,	 5.947,	 0.573,	 0.573,	 0.583,	 0.000,	 0.000],     // 24    Cr
    [5.899,	 5.888,	 6.490,	 6.490,	 0.637,	 0.637,	 0.649,	 0.000,	 0.000],     // 25    Mn
    [6.404,	 6.391,	 7.058,	 7.058,	 0.705,	 0.705,	 0.719,	 0.000,	 0.000],     // 26   Fe
    [6.930,	 6.915,	 7.649,	 7.649,	 0.776,	 0.776,	 0.791,	 0.000,	 0.000],     // 27
    [7.478,	 7.461,	 8.265,	 8.328,	 0.852,	 0.852,	 0.869,	 0.000,	 0.000],     // 28
    [8.048,	 8.028,	 8.905,	 8.976,	 0.930,	 0.930,	 0.950,	 0.000,	 0.000],     // 29
    [8.639,	 8.616,	 9.572,	 9.657,	 1.012,	 1.012,	 1.035,	 0.000,	 0.000],     // 30
    [9.252,	 9.225,	10.264,	10.365,	 1.098,	 1.098,	 1.125,	 0.000,	 0.000],     // 31
    [9.886,	 9.855,	10.982,	11.100,	 1.188,	 1.188,	 1.219,	 0.000,	 0.000],     // 32
    [10.544,	10.508,	11.726,	11.863,	 1.282,	 1.282,	 1.317,	 0.000,	 0.000],     // 33
    [11.222,	11.181,	12.496,	12.651,	 1.379,	 1.379,	 1.419,	 0.000,	 0.000],     // 34
    [11.924,	11.878,	13.291,	13.465,	 1.480,	 1.480,	 1.526,	 0.000,	 0.000],     // 35
    [12.649,	12.598,	14.112,	14.313,	 1.586,	 1.586,	 1.637,	 0.000,	 0.000],     // 36
    [13.395,	13.336,	14.961,	15.184,	 1.694,	 1.693,	 1.752,	 0.000,	 0.000],     // 37
    [14.165,	14.098,	15.836,	16.083,	 1.807,	 1.805,	 1.872,	 0.000,	 0.000],     // 38
    [14.958,	14.883,	16.738,	17.011,	 1.923,	 1.920,	 1.996,	 0.000,	 0.000],     // 39
    [15.775,	15.691,	17.668,	17.969,	 2.042,	 2.040,	 2.124,	 2.219,	 2.303],     // 40
    [16.615,	16.521,	18.623,	18.951,	 2.166,	 2.163,	 2.257,	 2.367,	 2.462],     // 41
    [17.479,	17.374,	19.608,	19.964,	 2.293,	 2.290,	 2.395,	 2.518,	 2.624],     // 42
    [18.367,	18.251,	20.619,	21.012,	 2.424,	 2.420,	 2.537,	 2.674,	 2.792],     // 43
    [19.279,	19.150,	21.657,	22.072,	 2.559,	 2.554,	 2.683,	 2.836,	 2.965],     // 44
    [20.216,	20.074,	22.724,	23.169,	 2.697,	 2.692,	 2.834,	 3.001,	 3.144],     // 45
    [21.177,	21.020,	23.819,	24.297,	 2.839,	 2.833,	 2.990,	 3.172,	 3.329],     // 46
    [22.163,	21.990,	24.942,	25.454,	 2.984,	 2.978,	 3.151,	 3.348,	 3.520],     // 47
    [23.174,	22.984,	26.096,	26.641,	 3.134,	 3.127,	 3.317,	 3.528,	 3.717],     // 48
    [24.210,	24.002,	27.276,	27.859,	 3.287,	 3.279,	 3.487,	 3.714,	 3.921],     // 49
    [25.271,	25.044,	28.486,	29.106,	 3.444,	 3.435,	 3.663,	 3.905,	 4.131],     // 50
    [26.359,	26.111,	29.726,	30.387,	 3.605,	 3.595,	 3.844,	 4.101,	 4.348],     // 51
    [27.472,	27.202,	30.996,	31.968,	 3.769,	 3.759,	 4.030,	 4.302,	 4.571],     // 52
    [28.612,	28.317,	32.295,	33.016,	 3.938,	 3.926,	 4.221,	 4.508,	 4.801],     // 53
    [29.779,	29.458,	33.624,	34.446,	 4.110,	 4.098,	 4.422,	 4.720,	 5.036],     // 54
    [30.973,	30.625,	34.987,	35.819,	 4.287,	 4.272,	 4.620,	 4.936,	 5.280],     // 55
    [32.194,	31.817,	36.378,	37.255,	 4.466,	 4.451,	 4.828,	 5.157,	 5.531],     // 56
    [33.442,	33.034,	37.801,	38.728,	 4.651,	 4.634,	 5.042,	 5.384,	 5.789],     // 57
    [34.720,	34.279,	39.257,	40.231,	 4.840,	 4.823,	 5.262,	 5.613,	 6.052],     // 58
    [36.026,	35.550,	40.748,	41.772,	 5.034,	 5.014,	 5.489,	 5.850,	 6.322],     // 59
    [37.361,	36.847,	42.271,	43.298,	 5.230,	 5.208,	 5.722,	 6.089,	 6.602],     // 60
    [38.725,	38.171,	43.826,	44.955,	 5.433,	 5.408,	 5.961,	 6.339,	 6.892],     // 61
    [40.118,	39.522,	45.413,	46.553,	 5.636,	 5.609,	 6.205,	 6.586,	 7.178],     // 62
    [41.542,	40.902,	47.038,	48.241,	 5.846,	 5.817,	 6.456,	 6.843,	 7.480],     // 63
    [42.996,	42.309,	48.697,	49.961,	 6.057,	 6.025,	 6.713,	 7.103,	 7.786],     // 64
    [44.482,	43.744,	50.382,	51.737,	 6.273,	 6.238,	 6.978,	 7.367,	 8.102],     // 65
    [45.998,	45.208,	52.119,	53.491,	 6.495,	 6.458,	 7.248,	 7.636,	 8.419],     // 66
    [47.547,	46.700,	53.877,	55.292,	 6.720,	 6.680,	 7.525,	 7.911,	 8.747],     // 67
    [49.128,	48.221,	55.681,	57.088,	 6.949,	 6.905,	 7.811,	 8.189,	 9.089],     // 68
    [50.742,	49.773,	57.517,	58.969,	 7.180,	 7.133,	 8.101,	 8.468,	 9.426],     // 69
    [52.389,	51.354,	59.370,	60.959,	 7.416,	 7.367,	 8.402,	 8.758,	 9.780],     // 70
    [54.070,	52.965,	61.283,	62.946,	 7.656,	 7.605,	 8.709,	 9.049,	10.143],     // 71
    [55.790,	54.611,	63.234,	64.936,	 7.899,	 7.845,	 9.023,	 9.347,	10.516],     // 72
    [57.532,	56.277,	65.223,	66.999,	 8.146,	 8.088,	 9.343,	 9.652,	10.895],     // 73
    [59.318,	57.982,	67.244,	69.090,	 8.398,	 8.335,	 9.672,	 9.962,	11.286],     // 74
    [61.140,	59.718,	69.310,	71.220,	 8.653,	 8.586,	10.010,	10.275,	11.685],     // 75
    [63.001,	61.487,	71.413,	73.393,	 8.912,	 8.841,	10.355,	10.599,	12.095],     // 76
    [64.896,	63.287,	73.561,	75.605,	 9.175,	 9.100,	10.708,	10.920,	12.513],     // 77
    [66.832,	65.112,	75.748,	77.866,	 9.442,	 9.362,	11.071,	11.251,	12.942],     // 78
    [68.804,	66.990,	77.984,	80.165,	 9.713,	 9.628,	11.442,	11.585,	13.382],     // 79   Au
    [70.819,	68.895,	80.253,	82.526,	 9.989,	 9.898,	11.823,	11.924,	13.830],     // 80   Hg
    [72.872,	70.832,	82.576,	84.904,	10.269,	10.173,	12.213,	12.272,	14.292],     // 81
    [74.969,	72.804,	84.936,	87.343,	10.552,	10.450,	12.614,	12.623,	14.764],     // 82   Pb
    [77.108,	74.815,	87.343,	89.833,	10.839,	10.731,	13.024,	12.980,	15.248],     // 83
    [79.290,	76.862,	89.800,	92.386,	11.131,	11.016,	13.447,	13.340,	15.744],     // 84
    [81.520,	78.950,	92.300,	94.976,	11.427,	11.305,	13.876,	13.705,	16.251],     // 85
    [83.780,	81.070,	94.870,	97.616,	11.727,	11.598,	14.316,	14.077,	16.770],     // 86
    [86.100,	83.230,	97.470, 100.305,	12.031,	11.895,	14.770,	14.450,	17.303],     // 87
    [88.470,	85.430, 100.130, 103.048,	12.340,	12.196,	15.236,	14.841,	17.849],     // 88
    [90.884,	87.670, 102.850, 105.838,	12.652,	12.501,	15.713,	15.227,	18.408],     // 89
    [93.350,	89.953, 105.609, 108.671,	12.969,	12.810,	16.202,	15.624,	18.983],     // 90
    [95.868,	92.287, 108.427, 111.575,	13.291,	13.122,	16.702,	16.024,	19.568],     // 91
    [98.439,	94.665, 111.300, 114.549,	13.615,	13.439,	17.220,	16.428,	20.167],     // 92
    [101.005, 97.023, 114.181, 117.533,	13.944,	13.760,	17.750,	16.840,	20.785],     // 93
    [103.653, 99.457, 117.146, 120.592,	14.279,	14.084,	18.294,	17.255,	21.417],     // 94
    [106.351, 101.932, 120.163, 123.706,	14.617,	14.412,	18.852,	17.677,	22.065]     // 95
    ];

    if ( line === EmissionLine.KAlpha ) {
      // K-alpha line (weighted average of K-alpha-1 and 2
      // from x-ray handbook, relative ratio is 2 to 1
      const alpha1 = emissionLine[zNumber][0];
      const alpha2 = emissionLine[zNumber][1];
      let alpha = alpha1;
      if (alpha2 > 0.) {
        alpha = (2. * alpha1 + alpha2) / 3.;
      }
      return Math.round(alpha * 100) / 100;
    } else if ( line === EmissionLine.KBeta) {
      return Math.round(emissionLine[zNumber][2] * 100) / 100;
    } else if ( line === EmissionLine.LAlpha) {
      // L-alpha line (weighted average of L-alpha-1 and 2
      // from x-ray handbook, relative ratio is 100 to 11
      const alpha1 = emissionLine[zNumber][4];
      const alpha2 = emissionLine[zNumber][5];
      let alpha = alpha1;
      if (alpha2 > 0.) {
        alpha = (100. * alpha1 + 11. * alpha2) / 111.;
      }
      return Math.round(alpha * 100) / 100;
    } else if ( line === EmissionLine.LBeta) {
      // L-beta line (weighted average of L-alpha-1 and 2
      // from x-ray handbook, relative ratio is 5 to 2
      const beta1 = emissionLine[zNumber][6];
      const beta2 = emissionLine[zNumber][7];
      let beta = beta1;
      beta = beta1;
      if (beta2 > 0) {
          beta = (5. * beta1 + 2. * beta2) / 7.;
      }
      return Math.round(beta * 100) / 100;
    }
    return 0;
  }
}
